/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_TitleInputs */

const en_notes_title = /** @type {(inputs: Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_notes_title = /** @type {(inputs: Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Notes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notes_title = /** @type {((inputs?: Notes_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notes_title(inputs)
	return en_notes_title(inputs)
});